import { MuiBox, TabPanel } from "components/atoms";
import React, { useEffect, useState } from "react";
import { CenterModalHeader } from "components/atoms";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetHelpAndFeedbackAction } from "store/middlewares/general";
import Pagination from "components/atoms/Pagination";
import HelpTab from "../HelpAndFeedbackTab/HelpTab";
import FeedbackTab from "../HelpAndFeedbackTab/FeedbackTab";
import NoDataFound from "components/atoms/NoDataFound";
import HelpTabSkeleton from "../SkeletonLoaders/HelpTabSkeleton";

const HelpAndFeedbackModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [value, setValue] = useState("help");
  const { helpAndFeedback, helpAndFeedbackLoading } = useSelector(
    (state) => state.general,
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //------------- pagination start-----------------
  const [pagination, setPagination] = useState({
    page: 1,
  });

  const handlePaginationChange = (newPage) => {
    setPagination((prev) => {
      if (prev.page === newPage) return prev;
      return {
        ...prev,
        page: newPage,
      };
    });
  };
  // ----------------------------- pagination end ---------------

  const helpAndFeedbackTabsList = [
    { label: t("modal.helpFeedback.help"), value: "help" },
    { label: t("modal.helpFeedback.feedback"), value: "feedback" },
  ];

  useEffect(() => {
    dispatch(GetHelpAndFeedbackAction({ page: pagination?.page }));
  }, [dispatch, pagination?.page]);

  return (
    <MuiBox sx={{ overflow: "auto", p: "0px" }}>
      <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "1px" }}>
        <CenterModalHeader title={t("modal.helpFeedback.helpFeedback")} />
        <MuiBox
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "background.white",
          }}
        >
          <MuiBox sx={{ px: "20px" }}>
            <MuiBox
              sx={{
                borderBottom: "1px solid",
                borderColor: "background.gray500",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" }, // ← stack on mobile
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: "space-between",
                gap: { xs: 1, sm: 0 }, // small gap when stacked
              }}
            >
              <Tabs value={value} onChange={handleChange}>
                {helpAndFeedbackTabsList?.map((item, index) => (
                  <Tab
                    key={item?.value || index}
                    label={item?.label}
                    value={item?.value}
                    disableRipple
                    sx={{ p: "12px", minWidth: "fit-content" }}
                  />
                ))}
              </Tabs>

              {value === "help" && (
                <MuiBox
                  sx={{
                    width: "fit-content",
                    alignSelf: { xs: "flex-end", sm: "auto" }, // right-align pagination on mobile
                    pb: { xs: 1, sm: 0 }, // optional small bottom padding on mobile
                  }}
                >
                  <Pagination
                    pageNo={pagination?.page}
                    limit={helpAndFeedback?.limit}
                    total={helpAndFeedback?.total}
                    onChange={handlePaginationChange}
                  />
                </MuiBox>
              )}
            </MuiBox>
          </MuiBox>

          {helpAndFeedbackTabsList?.map((item, index) => (
            <TabPanel
              key={index}
              tabValue={item?.value}
              selectedValue={value}
              sx={{ pt: "0px" }}
            >
              {value === "help" &&
                (helpAndFeedback?.list?.length > 0 ? (
                  <HelpTab />
                ) : helpAndFeedbackLoading ? (
                  <HelpTabSkeleton />
                ) : (
                  // <MuiBox sx={{ py: "50px" }}>
                  //   <CustomLoader />
                  // </MuiBox>
                  <MuiBox
                    sx={{
                      height: "100%",
                      p: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <NoDataFound title="modal.helpFeedback.noHelpArticlesAvailable" subTitle="modal.helpFeedback.noHelpArticlesAvailableDescr" />
                  </MuiBox>
                ))}
              {value === "feedback" && <FeedbackTab />}
            </TabPanel>
          ))}
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

export default HelpAndFeedbackModal;
